import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Popover, TextField, InputAdornment, styled, List, Typography, ListItem, Checkbox } from '@mui/material';
import { ArrowRight, BuildCircle } from '@mui/icons-material';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import { SimpleTreeView } from '@mui/x-tree-view';

import RecursiveListItem from './RecursiveList';
import NewViewPartyGroups from '../modals/newViewPartyGroup';

const CustomExpandIcon = styled(ArrowRight)(({ theme }) => ({
  color: theme.palette.primary.main, // Customize color
  fontSize: '25px !important', // Customize size
}));
const CustomCollapseIcon = styled(ArrowDropDownIcon)(({ theme }) => ({
  color: theme.palette.primary.main, // Customize color
  fontSize: '25px !important', // Customize size
}));

const NewCustomerGroup = ({
  accountGroup,
  subGroup,
  setCustomerGroup,
  loc,
  defaultGroup,
  customerState,
  partyGroupId,
  onChange,
  setup,
  label,
  disabled,
  getAccountData,
}) => {
  const [partyGrpModal, setPartyGrpModal] = useState();
  const [checkedLabel, setCheckedLabel] = useState('');
  let [expandIds, setExpandIds] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState();
  const [options, setOptions] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const openPopover = Boolean(anchorEl);
  const textfieldInRef = useRef(null);
  const textFieldRef = useRef(null);

  useEffect(() => {
    if (accountGroup[0]?.accountgroupid !== undefined) {
      getCustomerGroup();
    }
  }, [accountGroup]);
  const getPath = (value, data) => {
    const valueToItemMap = new Map(data.map((item) => [item.value, item]));

    let path = [];
    let current = valueToItemMap.get(value);

    while (current) {
      path.unshift(current.label); // Add label to the path at the start
      current = valueToItemMap.get(current.pgID.toString()); // Traverse to the parent
    }

    return path.join(' > '); // Join the path with " > "
  };
  function addParentKey(data) {
    const idToLabel = data?.reduce((acc, item) => {
      acc[item.value] = item.label;
      return acc;
    }, {});

    data?.forEach((item) => {
      item.parent = idToLabel[item.pgID] || null;
    });
    function countDescendants(node) {
      if (!node.children || node.children.length === 0) {
        return 0;
      }
      let count = node.children.length;
      node.children.forEach((child) => {
        count += countDescendants(child);
      });
      return count;
    }
    function sortTree(nodes) {
      nodes.forEach((node) => {
        node.descendantCount = countDescendants(node);
      });
      nodes.sort((a, b) => a.descendantCount - b.descendantCount);
      nodes.forEach((node) => {
        if (node.children && node.children.length > 0) {
          sortTree(node.children);
        }
      });
    }
    const buildTree = (data) => {
      const tree = [];
      const childrenOf = {};
      data?.forEach((item) => {
        item.children = childrenOf[item.value] = childrenOf[item.value] || [];
        const parentID = item.pgID;
        if (parentID && idToLabel[parentID]) {
          (childrenOf[parentID] = childrenOf[parentID] || []).push(item);
        } else {
          tree.push(item);
        }
      });
      sortTree(tree);
      return tree;
    };

    const flattenTree = (tree) => {
      let flat = [];
      tree.forEach((node) => {
        flat.push(node);
        if (node.children && node.children.length) {
          flat = flat.concat(flattenTree(node.children));
        }
      });
      return flat;
    };
    const tree = buildTree(data);
    let idS = flattenTree(tree)
      .filter((e) => e.children.length !== 0)
      .map((el) => el.value);

    setExpandIds(idS.length == 0 ? [flattenTree(tree)[0]?.value] : idS);
    return buildTree(data);
  }
  useEffect(() => {
    const optionskkk = options?.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }

      return 0;
    });
    const databb = addParentKey(optionskkk);
    setData(databb);
  }, [options]);
  console.log(options, 'options');

  async function getCustomerGroup(group) {
    try {
      let groupArr = [];
      let obj = {};
      groupArr.push({
        label: accountGroup[0]?.accountgroupname,
        value: `${accountGroup[0]?.accountgroupid}`,
        pgID: accountGroup[0]?.accountparentgroupid,
      });
      subGroup.map((ele) => {
        obj[ele.accountgroupid] = ele.accountgroupname;
        groupArr.push({
          label: ele.accountgroupname,
          value: `${ele.accountgroupid}`,
          pgID: ele.accountparentgroupid,
        });
      });
      setOptions(groupArr);

      const result = getPath(partyGroupId.toString(), groupArr);
      console.log(partyGroupId, result, 'result');

      setCheckedLabel(result);
    } catch (e) {
      console.log(e, 'error');
    }
  }
  const handleClick = (event) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheck = (item) => {
    console.log(item, options, 'item, options');

    const result = getPath(item, options);
    setCheckedLabel(result);
    handleClose();
  };

  useEffect(() => {
    if (openPopover) {
      setTimeout(() => {
        document.getElementById('searchCaegory')?.focus();
        if (textfieldInRef.current) {
          textfieldInRef.current.focus();
        }
      }, 200);
    }
  }, [openPopover, textfieldInRef]);
  console.log(data, 'datatat');
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };
  const handleCheckItems = (e, item) => {
    console.log(item, 'item');
  };
  console.log(checkedLabel, 'checkedLabel');

  return (
    <div style={{ width: '100%' }}>
      <TextField
        tabIndex={0}
        sx={{
          height: setup !== undefined || label !== undefined ? '34px' : '32px',
          mt: setup !== undefined || label !== undefined ? '' : '-2px',
          ml: setup !== undefined || label !== undefined ? '' : '-2px',
          width: '100%',
          '& .MuiInputBase-root': {
            padding: '0px',
          },
          outline: 'none',
        }}
        autoComplete="off"
        className="smaller-textfield"
        id="treeDrp"
        disabled={disabled}
        inputRef={textFieldRef}
        variant="outlined"
        value={checkedLabel}
        onClick={handleClick}
        fullWidth
        size="small"
        label={label}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          readOnly: true,
          style: { cursor: 'pointer' },
          endAdornment: (
            <InputAdornment position="end" sx={{ pr: '10px', cursor: 'pointer' }}>
              <ArrowDropDownIcon />
            </InputAdornment>
          ),
        }}
      />
      <Popover
        id="tree-popover"
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ maxHeight: '400px' }}
        onKeyDown={(e) => {
          if (e.key == 'Tab' && !document.activeElement.id == 'test') {
            handleClose();
          }
        }}
      >
        {options?.length > 5 && (
          <Box>
            <TextField
              id="searchCaegory"
              ref={textfieldInRef}
              inputRef={textfieldInRef}
              value={searchTerm}
              placeholder="Search"
              onChange={handleSearchChange}
              autoFocus={openPopover}
              size="small"
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                width: '95%',
                fontSize: 14,
                height: 40,
                m: 1,
                backgroundColor: '#faf5ef',
                borderRadius: '10px',
                color: '#26282A',
                '.MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                  outline: 'none',
                },
                '.MuiInputBase-input ': {
                  fontWeight: 'bold',
                },
                '.MuiSvgIcon-fontSizeMedium ': {
                  color: 'primary.main',
                  fontSize: '30px',
                },
              }}
              //   width: '100%',
              //   borderBottom: '1px solid',
              //   '& .MuiOutlinedInput-root': {
              //     '& fieldset': {
              //       border: 'none', // Remove the default border
              //     },
              //     '&:hover fieldset': {
              //       border: 'none', // Remove the hover border
              //     },
              //     '&.Mui-focused fieldset': {
              //       border: 'none', // Remove the focus border
              //     },
              //     '&:before': {
              //       borderBottom: '2px solid #000', // Add the bottom border
              //     },
              //     '&:after': {
              //       borderBottom: '2px solid #000', // Add the bottom border on focus
              //     },
              //   },
              //   '& .MuiInputBase-root': {
              //     '&:before': {
              //       borderBottom: '2px solid #000', // Add the bottom border
              //     },
              //     '&:after': {
              //       borderBottom: '2px solid #000', // Add the bottom border on focus
              //     },
              //   },
              // }}
              onKeyDown={(e) => {
                if (e.key == 'ArrowDown') {
                  textfieldInRef.current.focus();
                }
              }}
            />
          </Box>
        )}
        {searchTerm == '' ? (
          <Box sx={{ maxHeight: '200px', overflowY: 'auto', minWidth: '175px' }}>
            <SimpleTreeView
              aria-label="customized"
              defaultExpandedItems={expandIds}
              slots={{
                expandIcon: CustomExpandIcon,
                collapseIcon: CustomCollapseIcon,
              }}
              sx={{
                overflow: 'hidden',
                minHeight: 50,
                flexGrow: 1,
                padding: '0px',
              }}
            >
              {data?.map((item) => (
                <RecursiveListItem
                  key={item.value}
                  item={item}
                  data={options}
                  getPath={getPath}
                  checkedLabel={checkedLabel}
                  setCheckedLabel={setCheckedLabel}
                  searchTerm={searchTerm}
                  setCustomerGroup={setCustomerGroup}
                  partyGroupId={partyGroupId}
                  onCheck={handleCheck}
                />
              ))}
            </SimpleTreeView>
          </Box>
        ) : (
          <Box sx={{ minHeight: '200px', overflowY: 'auto', minWidth: '175px' }}>
            <List sx={{ height: '30px' }}>
              {options?.filter((item) => item.label.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0).length == 0 ? (
                <Typography variant="body1" sx={{ pl: 2, pt: 1 }}>
                  No options
                </Typography>
              ) : (
                options
                  ?.filter((item) => item.label.toLowerCase().indexOf(searchTerm) >= 0)
                  ?.map((item) => {
                    console.log(item, 'itemitem');

                    return (
                      <ListItem
                        sx={{ mt: 0, mb: 0, pt: 0, pb: 0, p: 0, pl: 2, cursor: 'pointer' }}
                        key={item.value}
                        onClick={() => {
                          setCustomerGroup(item.value);
                          handleCheck(item.value);
                          setSearchTerm('');
                        }}
                      >
                        <Checkbox sx={{ fontSize: '10px', padding: '2px' }} />
                        <Typography variant="body1">{item.label}</Typography>
                      </ListItem>
                    );
                  })
              )}
            </List>
          </Box>
        )}
        <Box
          sx={{
            boxShadow: '0px -4px 10px -2px rgba(0, 0, 0, 0.2)',
            width: '100%',
          }}
        >
          <Button
            sx={{ whiteSpace: 'nowrap', m: 0 }}
            startIcon={<BuildCircle />}
            onClick={() => {
              setPartyGrpModal(true);
            }}
          >
            Add Group
          </Button>
        </Box>
      </Popover>
      {partyGrpModal == true ? (
        <NewViewPartyGroups
          open={partyGrpModal}
          setNewGp={setCustomerGroup}
          setOpen={setPartyGrpModal}
          partyGroups={options}
          loc={loc}
          setData={setData}
          data={data}
          defaultGroup={defaultGroup}
          getAccountData={getAccountData}
        />
      ) : null}
    </div>
  );
};

export default NewCustomerGroup;
